import { render } from "./customFields.vue?vue&type=template&id=9294649c&scoped=true"
import script from "./customFields.vue?vue&type=script&lang=js"
export * from "./customFields.vue?vue&type=script&lang=js"

import "./customFields.vue?vue&type=style&index=0&id=9294649c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9294649c"]])

export default __exports__